import { render, staticRenderFns } from "./ShopSelectDialog.vue?vue&type=template&id=3cd873c3&scoped=true"
import script from "./ShopSelectDialog.vue?vue&type=script&lang=js"
export * from "./ShopSelectDialog.vue?vue&type=script&lang=js"
import style0 from "./ShopSelectDialog.vue?vue&type=style&index=0&id=3cd873c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd873c3",
  null
  
)

export default component.exports